import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import Logo from '../../components/Logo';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { toast } from 'sonner';
import api, { apiError } from '../../lib/api';

// Landing page of the password-reset email link: /auth/reset?token=...
export default function ResetPassword() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) { toast.error('Le mot de passe doit faire au moins 8 caractères'); return; }
    if (password !== confirm) { toast.error('Les deux mots de passe ne sont pas identiques'); return; }
    setLoading(true);
    try {
      await api.post('/auth/reset-password', { token, new_password: password });
      toast.success('Mot de passe enregistré — tu peux te connecter');
      nav('/auth/login');
    } catch (err) {
      toast.error(apiError(err, 'Ce lien est invalide ou périmé'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#06060a] grid-bg flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
        <div className="rounded-3xl border border-white/10 bg-[#0B0B0E]/80 backdrop-blur-xl p-8">
          <div className="flex flex-col items-center mb-6"><Logo size="lg" /></div>
          <h1 className="text-3xl font-display font-bold text-white text-center mb-2">Nouveau mot de passe</h1>
          {!token ? (
            <div className="rounded-xl border border-rose-500/30 bg-rose-500/10 p-4 text-sm text-rose-300 text-center mt-5">
              Ce lien est incomplet. Ouvre le lien depuis l’e-mail qu’on t’a envoyé, ou
              {' '}<Link to="/auth/forgot-password" className="underline">demandes-en un nouveau</Link>.
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4 pt-3">
              <div className="space-y-1.5">
                <Label className="text-slate-300">Nouveau mot de passe</Label>
                <Input data-testid="reset-password-input" type="password" value={password} onChange={e => setPassword(e.target.value)} className="bg-white/5 border-white/10 text-white h-11" required />
              </div>
              <div className="space-y-1.5">
                <Label className="text-slate-300">Confirme le mot de passe</Label>
                <Input data-testid="reset-confirm-input" type="password" value={confirm} onChange={e => setConfirm(e.target.value)} className="bg-white/5 border-white/10 text-white h-11" required />
              </div>
              <Button data-testid="reset-submit-button" type="submit" disabled={loading} className="w-full bg-indigo-500 hover:bg-indigo-600 text-white h-11">
                {loading ? 'Enregistrement...' : 'Enregistrer le mot de passe'}
              </Button>
            </form>
          )}
          <div className="text-center text-sm pt-5">
            <Link to="/auth/login" className="text-indigo-400 hover:text-indigo-300">Revenir à la connexion</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
